module.exports = __webpack_public_path__ + "static/img/neck_detail.28f9aace.png";